function isSerchLoaded() {
    return Boolean(document.getElementById('swell-popup'));
}

function showTemporalSearchBar() {
    const temporalSearchBar = document.querySelector('.js-search-bar-temporal');
    const temporalSearchBarInput = document.querySelector('.js-search-bar-temporal input');

    if (temporalSearchBar) {
        temporalSearchBar.style.display = 'block';
        temporalSearchBarInput.focus();
    }
}

function hideTemporalSearchBar() {
    const temporalSearchBar = document.querySelector('.js-search-bar-temporal');
    if (temporalSearchBar) temporalSearchBar.style.display = 'none';
}

function openSearchMobile() {
    const mobileSearch = document.querySelector('.search-mobile');
    mobileSearch.click();
}

function handleTemporalSearchBar() {

    if (window.searchBarMobileLoaded) return;

    showTemporalSearchBar();
    listenToSearchMobile();

}

function handleSearchMutation(observer) {
    const isSearchLoaded = isSerchLoaded();

    if (isSearchLoaded) {
        window.searchBarMobileLoaded = true;
        const mobileSearch = document.querySelector('.search-mobile');
        const searchValue = document.querySelector('.js-search-bar-temporal input')?.value;

        setTimeout(() => {
            mobileSearch.removeEventListener('click', handleTemporalSearchBar)
            mobileSearch.click();
            const realSearchInput = document.getElementById('snize-mobile-search-input');

            if (realSearchInput) realSearchInput.value = searchValue;

            realSearchInput.focus();
            hideTemporalSearchBar();

            const changeEvent = new Event("keydown");
            realSearchInput.dispatchEvent(changeEvent);
            observer.disconnect();
            hideTemporalSearchBar();

        }, 200)

    }
}

function listenToSearchMobile() {

    const targetNode = document.body;

    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
                handleSearchMutation(observer);
            }
        }
    });

    const config = { childList: true };

    observer.observe(targetNode, config);
}



document.addEventListener('DOMContentLoaded', function () {

    const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
    if (!isMobile) return;

    const mobileSearch = document.querySelector('.search-mobile');
    mobileSearch.addEventListener('click', handleTemporalSearchBar);

    const closeTemporalSearchBar = document.querySelector('.js-temporal-search-back-icon');
    closeTemporalSearchBar.addEventListener('click', hideTemporalSearchBar);
})

const showBottomBarOnScroll = () => {
    const bottomNav = document.querySelector(".section-bottom-navigation");
    if (bottomNav) {
        document.addEventListener("scroll", function onScroll() {
            if (window.scrollY > 0) {
                bottomNav.style.opacity = 1;
                bottomNav.style.height = "auto";
            } else {
                bottomNav.style.opacity = 0;
                bottomNav.style.height = 0;
            }
        });
    }
};


document.addEventListener('DOMContentLoaded', showBottomBarOnScroll);